import { persistReducer, REHYDRATE } from "redux-persist";
import AsyncStorage from '@react-native-community/async-storage';


const initialState = {
  online: navigator.onLine
};

function SwReducer(state : any = initialState,action : any){
    let nextState;

    switch (action.type){
        case 'ONLINE_STATUS':
            nextState = _setOnline(state, action);
            return nextState || state;
        case REHYDRATE:
            return {...state, online: navigator.onLine}
        default :
            return state;
    }
}


function _setOnline(state : any, action : any){
   return {...state, online: action.value}
}

export function setOnline(online) {
  return (dispatch) => {
    return dispatch({'type': 'ONLINE_STATUS', 'value': online});
  }
}


const persistConfig = {
  key: "sw",
  storage : AsyncStorage,
  blacklist: ['online']
}


export default persistReducer(persistConfig, SwReducer);

